<template>
    <div class="w-100">
        <b-dropdown 
            id="internal-user-dropdown"
            right
            dropup
            no-caret 
            boundary="window"
            class="spl-nav-dropdown w-100"
            toggle-class="px-2 py-3 w-100"
            menu-class="font-size-100"
        >
            <template v-slot:button-content>
                <div class="d-flex justify-content-center align-items-center w-100">
                    <div>
                        <b-avatar size="2rem" variant="primary" :text="currentUserInfo.initials"></b-avatar>
                    </div>
                    <div class="mx-2 text-wrap text-left">{{ currentUserInfo.user_full_name || currentUserInfo.full_name }}</div>
                    <div>
                        <b-icon icon="chevron-up"></b-icon>
                    </div>
                </div>
            </template>
            <b-dropdown-item v-if="languageSwitcherEnabled" link-class="d-flex align-items-center" @click="openLanguageSwitcher">
                <b-icon icon="translate" variant="primary" class="mr-2"></b-icon>
                <div class="d-inline-block text-left ml-1">
                    <div class="font-weight-500 text-black">{{ currentLanguageLabel }}</div>
                    <div class="special-text text-muted font-size-70">{{ $t('userDropdownMessages.clickToChange') }}</div>
                </div>
            </b-dropdown-item>
            <b-dropdown-divider v-if="languageSwitcherEnabled"></b-dropdown-divider>
            <b-dropdown-item @click="startLogout">
                <b-icon icon="box-arrow-right" variant="danger" class="mr-2"></b-icon>
                {{ $t('userDropdownMessages.signOut') }}
            </b-dropdown-item>
            <b-dropdown-divider></b-dropdown-divider>
            <b-dropdown-item @click="$beacon('toggle')">
                <b-icon icon="question-circle" variant="info" class="mr-2"></b-icon>
                {{ $t('userDropdownMessages.support') }}
            </b-dropdown-item>
            <b-dropdown-item :href="splUrlMap.user_profile" target="_blank">
                <b-icon icon="person-lines-fill" variant="primary" class="mr-2"></b-icon>
                {{ $t('userDropdownMessages.account') }}
            </b-dropdown-item>
        </b-dropdown>
        <logout-confirm
            ref="logoutConfirm"
        ></logout-confirm>
        <language-switcher-modal
            ref="languageSwitcherModal"
        ></language-switcher-modal>
    </div>
</template>

<script>
import { currentUserInfoMixin, splUrlMapMixin } from '../../js/custom-vue-mixins';
import LanguageSwitcherModal from '../shared/LanguageSwitcherModal.vue';
import { userDropdownMessages } from '@/localization/shared/userDropdown';

export default {
    name: 'InternalUserDropdown',
    components: {
        LanguageSwitcherModal,
    },
    mixins: [
        currentUserInfoMixin,
        splUrlMapMixin,
    ],
    i18n: {
        messages: userDropdownMessages,
    },
    props: {
    },
    data: function() {
        return {
            errorMsg: 'Error',
            error: false,
        }
    },
    computed: {
        languageSwitcherEnabled: function() {
            // TODO - get from tenant settings?
            return !!this.$i18nData.enabled;
        },
        currentLanguageLabel: function() {
            return this.$i18nData.lang_info.name_translated || '';
        },
    },
    methods: {
        startLogout: function() {
            // call logout() method on component, which will show the confirm modal
            this.$refs.logoutConfirm.logout()
        },
        openLanguageSwitcher: function() {
            this.$refs.languageSwitcherModal.show()
        }
    }
}
</script>

<style lang="scss">

#internal-user-dropdown {
    background-color: rgba(255,255,255,0.05);
    transition: 0.2s ease;
    &:hover {
        background-color: rgba(255,255,255,0.1);
    }
}

</style>
